import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from "@angular/forms";
import { Ng2CompleterModule } from "ng2-completer";
import { HttpModule, Http } from '@angular/http';
import { TranslatePipe, TranslateService, TranslateModule, TranslateStaticLoader, TranslateLoader } from 'ng2-translate';
import { RouterModule } from '@angular/router';

import { AppComponent } from './app.component';

//Main Components
import { HomeComponent } from './main/home/home.component';
import { StudioComponent } from './main/studio/studio.component';
import { ContactComponent } from './main/contact/contact.component';

//Project Components
import { MvevaComponent } from './projects/mveva/mveva.component';
import { AplifitComponent } from './projects/aplifit/aplifit.component';
import { CatlishComponent } from './projects/catlish/catlish.component';
import { WuikStudioComponent } from './projects/wuik_studio/wuik-studio.component';
import { AjuntamentVallBasComponent } from './projects/ajuntament_vall_bas/ajuntament-vall-bas.component';
import { ValeriComponent } from './projects/valeri/valeri.component';
import { CanGuidicComponent } from './projects/can_guidic/can-guidic.component';
import { VictorSantacanaComponent } from './projects/victor_santacana/victor-santacana.component';
import { AliciaVogelComponent } from './projects/alicia_vogel/alicia-vogel.component';
import { MasCorominolaComponent } from './projects/mas_corominola/mas-corominola.component';
import { AltresComponent } from './projects/altres/altres.component';

@NgModule({
  imports: [
    BrowserModule,
    Ng2CompleterModule,
    FormsModule,
    HttpModule,
    TranslateModule.forRoot({
      provide: TranslateLoader,
      useFactory: (http: Http) => new TranslateStaticLoader(http, '/assets/i18n', '.json'),
      deps: [Http]
    }),
    RouterModule.forRoot([
      //Main Components:
      {
        path: 'home',
        component: HomeComponent
      },
      {
        path: 'studio',
        component: StudioComponent
      },
      {
        path: 'contact',
        component: ContactComponent
      },
      //Project Components:
      {
        path: 'aplifit',
        component: AplifitComponent
      },
      {
        path: 'mveva',
        component: MvevaComponent
      },
      {
        path: 'catlish',
        component: CatlishComponent
      },
      {
        path: 'wuik-studio',
        component: WuikStudioComponent
      },
      {
        path: 'ajuntament-vall-bas',
        component: AjuntamentVallBasComponent
      },
      {
        path: 'valeri',
        component: ValeriComponent
      },
      {
        path: 'can-guidic',
        component: CanGuidicComponent
      },
      {
        path: 'victor-santacana',
        component: VictorSantacanaComponent
      },
      {
        path: 'alicia-vogel',
        component: AliciaVogelComponent
      },
      {
        path: 'mas-corominola',
        component: MasCorominolaComponent
      },
      {
        path: 'altres',
        component: AltresComponent
      },      
      {
        path: '',
        redirectTo: 'home',
        pathMatch: 'full'
      }
    ], { useHash: true })
  ],
  declarations: [
    AppComponent,
    //Main Declarations:
    HomeComponent,
    StudioComponent,
    ContactComponent,
    //Project Declarations:
    AplifitComponent,
    MvevaComponent,
    CatlishComponent,
    WuikStudioComponent,
    AjuntamentVallBasComponent,
    ValeriComponent,
    CanGuidicComponent,
    MasCorominolaComponent,
    VictorSantacanaComponent,
    AliciaVogelComponent,
    AltresComponent
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }


/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/app.module.ts
 **/